import { render, staticRenderFns } from "./FormControlCurrency.vue?vue&type=template&id=20b21e58"
import script from "./FormControlCurrency.vue?vue&type=script&lang=js"
export * from "./FormControlCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b21e58')) {
      api.createRecord('20b21e58', component.options)
    } else {
      api.reload('20b21e58', component.options)
    }
    module.hot.accept("./FormControlCurrency.vue?vue&type=template&id=20b21e58", function () {
      api.rerender('20b21e58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Form/Control/FormControlCurrency.vue"
export default component.exports